import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const floatAnimation = keyframes`
	0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-10px);
	}
	100% {
		transform: translatey(0px);
	}
`

const SAnimalAvatar = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
  transform: translatey(0px);
  animation: ${floatAnimation} 4s ease-in-out infinite;
  height: 124px;
  width: 124px !important;
  border-radius: 50%;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;

  @media ${BREAKPOINTS.MD.max} {
    width: 66px !important;
    height: 66px;
  }
`

export const SDog = styled(SAnimalAvatar)`
  top: 18%;
  left: -5%;

  @media ${BREAKPOINTS.MD.max} {
    left: 0;
  }
`

export const SCat = styled(SAnimalAvatar)`
  bottom: -5%;
  left: 20%;
`

export const SParrot = styled(SAnimalAvatar)`
  top: 40%;
  right: -4%;

  @media ${BREAKPOINTS.MD.max} {
    display: none;
  }
`

export const SHamster = styled(SAnimalAvatar)`
  top: -5%;
  left: 50%;

  @media ${BREAKPOINTS.MD.max} {
    left: 60%;
  }
`
